<template>
  <div
    class="m-container m-center-screen -with-bottombar"
  >
    <PageHeader
      icon="exclamationCircle"
      iconSize="large"
      title="Zaznačte, či bola odpoveď na jednotlivé otázky uspokojivá alebo nie"
      center
    />
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
</script>
